import React from 'react';
import edgeCloudWordmark from '../../assets/icons/home/theta-edgecloud-wordmark.svg';
import distributedNetworkIcon from '../../assets/icons/home/distributed-edge-network.svg';
import cloudPartnersIcon from '../../assets/icons/home/enterprise-cloud-partners.svg';
import intelligentRoutingIcon from '../../assets/icons/home/intelligent-routing.svg';

const FeatureColumn = ({icon, title, description, badge, badgeHref, badgeIsAnchor}) => (
    <div className={'HowItWorks__feature'}>
        <img className={'HowItWorks__feature-icon'}
             src={icon}
             alt={title}
        />
        <h3 className={'HowItWorks__feature-title'}>{title}</h3>
        <p className={'HowItWorks__feature-description'}>{description}</p>
        <a className={'HowItWorks__feature-badge'}
           href={badgeHref}
           target={badgeIsAnchor ? undefined : '_blank'}
           rel={badgeIsAnchor ? undefined : 'noopener noreferrer'}
        >
            {badge}
            <span className={'HowItWorks__feature-badge-arrow'}>→</span>
        </a>
    </div>
);

const HowItWorksSection = ({icons}) => {
    return (
        <div className={'HowItWorks'} id={'how-it-works'}>
            <div className={'HowItWorks__header'}>
                <div className={'HowItWorks__section-label'}>
                    <span>How it works</span>
                    <div className={'HowItWorks__section-label-line'}/>
                </div>
                <div className={'HowItWorks__branding'}>
                    <img className={'HowItWorks__edgecloud-logo'}
                         src={edgeCloudWordmark}
                         alt={'Theta EdgeCloud'}
                    />
                </div>
                <h2 className={'HowItWorks__headline'}>
                    Hybrid Infrastructure<br/>that adapts
                </h2>
                <p className={'HowItWorks__subtitle'}>
                    Intelligent routing across 30,000+ edge nodes and enterprise
                    cloud infrastructure. Pay only for what you use.
                </p>
            </div>

            <div className={'HowItWorks__features'}>
                <FeatureColumn
                    icon={icons?.distributedNetwork || distributedNetworkIcon}
                    title={'Distributed Edge Network'}
                    description={'30,000+ nodes provide GPU capacity for inference and fine-tuning at consumer hardware prices.'}
                    badge={'30,000+ Edge Nodes'}
                    badgeHref={'#live-nodes'}
                    badgeIsAnchor
                />
                <FeatureColumn
                    icon={icons?.cloudPartners || cloudPartnersIcon}
                    title={'Enterprise Cloud Partners'}
                    description={'Access Google Cloud and AWS H200s, A100s, and Inferentia silicon for intensive training with enterprise reliability.'}
                    badge={'H200s & A100s Available'}
                    badgeHref={'https://www.thetaedgecloud.com/dashboard/ai/service/gpu-node'}
                />
                <FeatureColumn
                    icon={icons?.intelligentRouting || intelligentRoutingIcon}
                    title={'Trusted by Researchers'}
                    description={'Stanford, Imperial College London, and Peking University choose EdgeCloud for their GPU compute needs.'}
                    badge={'100s of PetaFLOPS Available'}
                    badgeHref={'https://www.thetaedgecloud.com'}
                />
            </div>
        </div>
    );
};

export default HowItWorksSection;
